/* eslint-disable camelcase, quotes */
export default {
    BUTTON: {
        title: 'Example Button Label',
        url: 'https://unsplash.it/800/600'
    },
    CALL_TO_ACTION_LEFT: {
        data: {
            content: '<h1>First Call to Action left</h1><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p><a class="button" href="/#" target="_blank">Button Text</a></p>',
            file: 'https://unsplash.it/800/600',
            content_position: 'left'
        }
    },
    CALL_TO_ACTION_RIGHT: {
        data: {
            content: '<h1>Second Call to Action right</h1><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p><a class="button" href="/#" target="_blank">Button Text</a></p>',
            file: 'https://unsplash.it/800/601',
            content_position: 'right'
        }
    },
    CALL_TO_ACTION_WITH_PADDING: {
        data: {
            content: '<h1>Third Call to Action with Padding</h1><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p><a class="button" href="/#" target="_blank">Button Text</a></p>',
            file: 'https://unsplash.it/800/601',
            content_position: 'right',
            padding_top: '1',
            padding_bottom: '1',
        }
    },
    CONTENT_SET: {
        items: [
            {
                type: 'page',
                data: {
                    name: 'Example Tile Title One',
                    slug: 'auckland-live',
                    thumbnail: 'https://unsplash.it/800/600',
                    seo_keywords: '...',
                    is_published: true,
                    seo_description: '...',
                    short_description: 'Consectetur adipiscing elit, sed do eiusmod tempor incididun duis aute irure dolor. Consectetur adipiscing elit, sed do eiusmod tempor incididun duis aute irure dolor',
                    id: 1,
                    disabled: false,
                    main_images: [],
                    subtitle: 'Subtitle'
                }
            },
            {
                type: 'page',
                data: {
                    name: 'Example Tile Title Two',
                    slug: 'auckland-conventions',
                    thumbnail: 'https://unsplash.it/800/601',
                    seo_keywords: '...',
                    is_published: true,
                    seo_description: '...',
                    short_description: 'Consectetur adipiscing elit, sed do eiusmod tempor incididun duis aute irure dolor. Consectetur adipiscing elit, sed do eiusmod tempor incididun duis aute irure dolor',
                    id: 1,
                    disabled: false,
                    main_images: [],
                    subtitle: 'Subtitle'
                }
            },
            {
                type: 'page',
                data: {
                    name: 'Example Tile Title Three: Breaking On To Two Lines',
                    slug: 'auckland-art-gallery',
                    thumbnail: 'https://unsplash.it/800/602',
                    seo_keywords: '...',
                    is_published: true,
                    seo_description: '...',
                    short_description: 'Consectetur adipiscing elit, sed do eiusmod tempor incididun duis aute irure dolor. Consectetur adipiscing elit, sed do eiusmod tempor incididun duis aute irure dolor',
                    id: 1,
                    disabled: false,
                    main_images: []
                }
            },
            {
                type: 'page',
                data: {
                    name: 'Example Tile Title Four: Much Longer Than Two Lines To Demonstrate Overflow',
                    slug: 'auckland-art-gallery',
                    thumbnail: 'https://unsplash.it/800/603',
                    seo_keywords: '...',
                    is_published: true,
                    seo_description: '...',
                    short_description: 'Consectetur adipiscing elit, sed do eiusmod tempor incididun duis aute irure dolor. Consectetur adipiscing elit, sed do eiusmod tempor incididun duis aute irure dolor',
                    id: 1,
                    disabled: false,
                    main_images: []
                }
            }
        ],
        title: "Content Set Title"
    },
    SWATCH: {
        items:  [
            {
                title: 'Primary',
                colour: 'primary',
                variations: ['tint-1', 'shade-1']
            },
            {
                title: 'Secondary',
                colour: 'secondary',
                variations: ['shade-1', 'shade-2']
            },
            {
                title: 'Tertiary',
                colour: 'tertiary',
                variations: ['shade-1', 'shade-2']
            },
            {
                title: 'Supplementary - Coral',
                colour: 'supplementary-1'
            },
            {
                title: 'Supplementary - Navy',
                colour: 'supplementary-2'
            }
        ]
    },
    TEXT_PROPS: {
        data: {
            content: '<h1>Main Text Content Heading</h1><p>Capitalize on low hanging fruit to identify a ballpark value added activity to beta test. Override the digital divide with additional clickthroughs from DevOps. Nanotechnology immersion along the information highway will close the loop on focusing solely on the bottom line.</p><p>Leverage agile frameworks to provide a robust synopsis for high level overviews. Iterative approaches to corporate strategy foster collaborative thinking to further the overall value proposition. Organically grow the holistic world view of disruptive innovation via workplace diversity and empowerment.</p><p>Bring to the table win-win survival strategies to ensure proactive domination. At the end of the day, going forward, a new normal that has evolved from generation X is on the runway heading towards a streamlined cloud solution. User generated content in real-time will have multiple touchpoints for offshoring.</p><blockquote><p>Sit amet, cu habeo accusamus sea, usu verear aliquam scaevola ea. Explicari definitionem vim ut. An has officiis convenire, ea eius ponderum suavitate.</p><em>Author&rsquo;s Name &ndash; Auckland Art Gallery</em></blockquote><p>Podcasting operational change management inside of workflows to establish a framework. Taking seamless key performance indicators offline to maximise the long tail. Keeping your eye on the ball while performing a deep dive on the start-up mentality to derive convergence on cross-platform integration.<p/><p>Collaboratively administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C users after installed base benefits. Dramatically visualize customer directed convergence without revolutionary ROI.</p><ul><li>Lorem Khaled Ipsum is a major key to success. They never said winning was easy. Some people can&rsquo;t handle success.</li><li>A major key, never panic. Don&rsquo;t panic, when it gets crazy and rough, don&rsquo;t panic, stay calm.</li><li>In life you have to take the trash out, if you have trash in your life, take it out, throw it away, get rid of it, major key</li><li>The weather is amazing, walk with me through the pathway of more success. Take this journey with me, Lion! Learning is cool, but knowing is better, and I know the key to success. Eliptical talk.</li></ul><p>Efficiently unleash cross-media information without cross-media value. Quickly maximize timely deliverables for real-time schemas. Dramatically maintain clicks-and-mortar solutions without functional solutions.<p/><p>Completely synergize resource taxing relationships via premier niche markets. Professionally cultivate one-to-one customer service with robust ideas. Dynamically innovate resource-leveling customer service for state of the art customer service.</p><a class="button" href="/#">Button Text</a>'
        }
    },
    TEXT_ASIDE_PROPS: {
        data: {
            content: '<h1>Text with aside</h1><p>Lorem ipsum dolor sit amet, <strong>consectetur adipiscing elit</strong>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>',
            aside: '<p>Bring to the table win-win survival strategies to ensure proactive domination. At the end of the day, going forward, a new normal that has evolved from generation X is on the runway heading towards a streamlined cloud solution.</p><a class="button" href="/#">Button Text</a>'
        }
    },
    TEXT_ASIDE_WITH_TITLE_PROPS: {
        data: {
            content: '<h1>Text with aside</h1><p>Lorem ipsum dolor sit amet, <strong>consectetur adipiscing elit</strong>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p><a class="button" href="/#">Button Text</a>',
            aside: '<h1>Text aside with title</h1><p>Bring to the table win-win survival strategies to ensure proactive domination. At the end of the day, going forward, a new normal that has evolved from generation X is on the runway heading towards a streamlined cloud solution.</p><a class="button" href="/#">Button Text</a>'
        }
    },
    TEXT_QUOTE_PROPS: {
        data: {
            content: '<h1>Text with quote</h1><p>Lorem ipsum dolor sit amet, <strong>consectetur adipiscing elit</strong>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>',
            quote: 'Sit amet, cu habeo accusamus sea, usu verear aliquam scaevola ea. Explicari definitionem vim ut. An has officiis convenire, ea eius ponderum suavitate.',
            citation: 'Example citation text'
        }
    },
    HERO_CAROUSEL: {
        items: [
            {
                title: 'Slide One Title',
                description: 'Sunday 11th March 2018, QBE Stadium',
                link: '#',
                file: 'https://picsum.photos/1640/900/?random'
            },
            {
                title: 'Slide Two Title',
                description: 'Saturday 15th Decemeber 2017, Aotea Centre',
                link: '#',
                file: 'https://picsum.photos/1640/901/?random'
            },
            {
                title: 'Slide Three Title',
                description: 'Friday 9th November 2017, Mt Smart Stadium',
                link: '#',
                file: 'https://picsum.photos/1640/902/?random'
            }
        ]
    },
    IMAGE_CAROUSEL: {
        items:  [
            {
                title: 'Summer Pops – Music From The Movies',
                file: 'https://unsplash.it/800/600',
                subtitle: 'Be swept away as the New Zealand Symphony Orchestra goes widescreen and takes you on a magical movie-themed adventure. Conducted by Associate Conductor Hamish McKeich, join us as we perform some of the most popular themes in movie history.',
                link: 'https://www.aucklandlive.co.nz/show/summer-pops-music-from-the-movies'
            },
            {
                title: 'Best Foods Comedy Gala',
                file: 'https://unsplash.it/800/601',
                subtitle: 'Hosted by crowd favourite Arj Barker, this year’s Best Foods Comedy Gala launches the 2018 NZ International Comedy Festival with one hell of an illustrious night of comedy.',
                link: 'https://www.aucklandlive.co.nz/show/best-foods-comedy-gala'
            },
            {
                title: 'The Nutcracker: Moscow Ballet Classique',
                file: 'https://unsplash.it/800/602',
                subtitle: 'La Classique was founded in 1990 by its current director, Elik Melikov. La Classique -  with its artistic ballet mastery, lavish costumes and magnificent stage sets -  will take us on a journey back in time to the frost-covered, gas-lit world of Clara, her beloved nutcracker doll and the magician Drosselmeyer.',
                link: 'https://www.aucklandlive.co.nz/show/the-nutcracker-moscow-ballet-classique'
            },
            {
                title: 'Postmodern Jukebox',
                file: 'https://unsplash.it/800/603',
                subtitle: 'Bringing their vintage twist on modern pop songs back to fans across the country, New Zealand loves Postmodern Jukebox. Following three successful tours in as many years, the multi-talented collective will bring their re-imagined contemporary pop, rock and R&B hits in the style of various yesteryears back to eagerly awaiting fans in 2018.',
                link: 'https://www.aucklandlive.co.nz/show/postmodern-jukebox'
            },
            {
                title: 'Dinner In The Sky',
                file: 'https://unsplash.it/800/604',
                subtitle: 'For the first time, Dinner In The Sky is coming to New Zealand and you can be amongst the first to experience this truly unique dining experience this summer, next to The Cloud at Queens Wharf, Auckland.',
                link: 'https://www.aucklandlive.co.nz/show/dinner-in-the-sky'
            }
        ]
    },
    IMAGE_GALLERY_SINGLE: {
        items: [
            {
                creditline: '<p><strong>Image Two Title</strong></p><p>Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p><a href="#">Read more</a></p>',
                file: 'https://unsplash.it/800/600'
            },
            {
                creditline: '<p><strong>Image One Title</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Excepteur sint occaecat cupidatat non proident.</p><p><a href="#">Read more</a></p>',
                file: 'https://unsplash.it/800/601'
            }
        ]
    },
    IMAGE_GALLERY_MULTIPLE: {
        items: [
            {
                creditline: '<p><strong>Image One Title</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>',
                file: 'https://unsplash.it/800/600'
            },
            {
                creditline: '<p><strong>Image Two Title</strong></p><p>Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>',
                file: 'https://unsplash.it/800/601'
            },
            {
                creditline: '<p><strong>Image Three Title</strong></p><p>Consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>',
                file: 'https://unsplash.it/800/602'
            },
            {
                creditline: '<p><strong>Image Four Title</strong></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>',
                file: 'https://unsplash.it/800/603'
            },
            {
                creditline: '<p><strong>Image Five Title</strong></p><p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat id est laborum.</p>',
                file: 'https://unsplash.it/800/604'
            },
            {
                creditline: '<p><strong>Image Six Title</strong></p><p>Labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat.</p>',
                file: 'https://unsplash.it/800/605'
            },
        ],
    },
    VIDEO: {
        data: {
            title: 'This is a title',
            video_url: 'https://www.youtube.com/watch?v=RJLm9dqB8Nk',
            credit: 'Credit - Auckland Live',
            theme_colour: 'teal'
        }
    },
    PAGEBREAK_QUOTE_LEFT: {
        file: 'https://unsplash.it/800/600',
        quote: 'Lorem ipsum dolor sit amet, cu habeo accusamus sea, usu verear aliquam scaev explicari definitionem vim ut.',
        cite: 'Author’s Name – Auckland Art Gallery',
        content_position: 'left',
        theme: 'teal'
    },
    PAGEBREAK_QUOTE_RIGHT: {
        file: 'https://unsplash.it/800/604',
        quote: 'Lorem ipsum dolor sit amet, cu habeo accusamus sea, usu verear aliquam scaev explicari definitionem vim ut.',
        cite: 'Author’s Name – Auckland Live',
        content_position: 'right',
        theme: 'teal'
    },
    PAGEBREAK_QUOTE_NO_IMAGE: {
        file: '',
        quote: 'Lorem ipsum dolor sit amet, cu habeo accusamus sea, usu verear aliquam scaev explicari definitionem vim ut.',
        cite: 'Author’s Name – Auckland Stadiums',
        theme: 'teal'
    },
    FAQ: {
        items: [
            {
                content: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p>Lorem ipsum dolor sit amet:</p><ul><li>Consectetur adipiscing elit.</li><li>Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.&nbsp;</li><li>Ut enim ad minim veniam.</li></ul><p>Egestas pretium aenean pharetra magna ac. Iaculis eu non diam phasellus vestibulum. Lectus sit amet est placerat in egestas erat. Egestas integer eget aliquet nibh praesent tristique magna. Aliquet nibh praesent tristique magna sit. Ultricies mi eget mauris pharetra et ultrices. Nullam eget felis eget nunc lobortis. Feugiat scelerisque varius morbi enim nunc faucibus a. Convallis a cras semper auctor. Diam sollicitudin tempor id eu nisl nunc mi ipsum faucibus. Tellus id interdum velit laoreet id donec. Cursus in hac habitasse platea dictumst quisque sagittis purus. Ut morbi tincidunt augue interdum velit euismod in pellentesque massa. Nisl purus in mollis nunc. Feugiat nisl pretium fusce id velit ut tortor pretium viverra. Facilisis sed odio morbi quis commodo odio aenean sed. Volutpat blandit aliquam etiam erat velit scelerisque in. Ut morbi tincidunt augue interdum velit euismod in pellentesque. Fusce id velit ut tortor pretium viverra suspendisse potenti nullam. Sollicitudin nibh sit amet commodo nulla facilisi nullam vehicula. Non tellus orci ac auctor augue mauris augue neque gravida. Velit sed ullamcorper morbi tincidunt ornare massa eget egestas purus. Amet aliquam id diam maecenas ultricies mi eget. Id semper risus in hendrerit gravida. Scelerisque eu ultrices vitae auctor eu augue. Tortor posuere ac ut consequat semper viverra nam.</p>',
                heading: 'Frequently Asked Questions',
                title: 'Question with a big amount of content?'
            },
            {
                content: '<p>Egestas pretium aenean pharetra magna ac. Iaculis eu non diam phasellus vestibulum. Lectus sit amet est placerat in egestas erat. Egestas integer eget aliquet nibh praesent tristique magna. Aliquet nibh praesent tristique magna sit. Ultricies mi eget mauris pharetra et ultrices. Nullam eget felis eget nunc lobortis. Feugiat scelerisque varius morbi enim nunc faucibus a. Convallis a cras semper auctor. Diam sollicitudin tempor id eu nisl nunc mi ipsum faucibus.</p>',
                heading: '',
                title: 'A question with a normal amount of content?'
            },
            {
                content: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>',
                heading: '',
                title: 'A long question in words. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt?'
            },
            {
                content: '<p>Volutpat sed cras ornare arcu dui. Lacus luctus accumsan tortor posuere ac ut consequat. Nunc scelerisque viverra mauris in aliquam. Sit amet nulla facilisi morbi tempus iaculis urna id.</p>',
                heading: '',
                title: 'Another normal question?'
            }
        ]
    },
    FILE_DOWNLOAD_1: {
        extension: "pdf",
        filename: "RFA invoice - Terms and conditions.pdf",
        filesize: "2466780",
        file: "RFA invoice - Terms and conditions.pdf"
    },
    FILE_DOWNLOAD_2: {
        extension: "png",
        filename: "RFA Team - Meet our team.png",
        filesize: "466780",
        file: "RFA Team - Meet our team.png"
    },
    FILE_DOWNLOAD_3: {
        extension: "pdf",
        filename: "RFA Venues.pdf",
        filesize: "333232323",
        file: "RFA Venues.pdf"
    },
    TABLE: {
        title: 'Test Table',
        cols: ['Event', 'Date', 'Location', 'Investment level'],
        rows: [
            ['New Zealand Game Championships', '23 - 24 March', 'Auckland', '$0,000,000'],
            ['New Zealand Game Championships', '23 - 24 March', 'Auckland', '$0,000,000'],
            ['New Zealand Game Championships', '23 - 24 March', 'Auckland', '$0,000,000'],
            ['New Zealand Game Championships', '23 - 24 March', 'Auckland', '$0,000,000'],
            ['New Zealand Game Championships', '23 - 24 March', 'Auckland', '$0,000,000'],
            ['New Zealand Game Championships', '23 - 24 March', 'Auckland', '$0,000,000'],
            ['New Zealand Game Championships', '23 - 24 March', 'Auckland', '$0,000,000'],
            ['New Zealand Game Championships', '23 - 24 March', 'Auckland', '$0,000,000'],
            ['New Zealand Game Championships', '23 - 24 March', 'Auckland', '$0,000,000'],
            ['New Zealand Game Championships', '23 - 24 March', 'Auckland', '$0,000,000'],
            ['New Zealand Game Championships', '23 - 24 March', 'Auckland', '$0,000,000'],
            ['New Zealand Game Championships', '23 - 24 March', 'Auckland', '$0,000,000'],
            ['New Zealand Game Championships', '23 - 24 March', 'Auckland', '$0,000,000']
        ]
    },
    FLEXI: {
        items: [
            {
                title: 'Flexi title 1',
                content: '<p>Convallis volutpat. Dis nisi varius habitant senectus sociis nulla leo in non eget urna cubilia risus sodales phasellus diam ultricies semper Sollicitudin aliquet curae;. Phasellus metus in dapibus.</p>',
                button: {
                    label: 'Flexi button label',
                    href: '/'
                },
                file: 'https://unsplash.it/400/300',
            },
            {
                title: 'Flexi title 2',
                content: '<p>Convallis volutpat. Dis nisi varius habitant senectus sociis nulla leo in non eget urna cubilia risus sodales phasellus diam ultricies semper Sollicitudin aliquet curae;. Phasellus metus in dapibus.</p>',
                button: {
                    label: 'Flexi button label',
                    href: '/'
                },
                file: 'https://unsplash.it/400/301',
            }
        ]
    }
};
